"use strict";
var appn;
(function (appn) {
    var modalStandard;
    (function (modalStandard) {
        const _modalTextSearchSelector = '#connectorsDialog.modal.modalHasTextSearch .modalTextSearch';
        function init() {
            const modalTextSearchInput = $(_modalTextSearchSelector);
            if (!appn.utils.hasValue(modalTextSearchInput))
                return;
            modalTextSearchInput.focus();
            addEvents(modalTextSearchInput);
        }
        modalStandard.init = init;
        function initFullscreenToggle() {
            $(document).on('click', '.btn-toggle-fullscreen', function () {
                const $btn = $(this);
                const $modal = $btn.closest('.modal');
                const $dialog = $modal.find('.modal-dialog');
                $dialog.toggleClass('modal-fullscreen');
                const isFullscreen = $dialog.hasClass('modal-fullscreen');
                $btn.find('i')
                    .toggleClass('fa-expand', !isFullscreen)
                    .toggleClass('fa-compress', isFullscreen);
                $modal.trigger('fullscreenToggled', [isFullscreen]);
            });
            $(document).on('hidden.bs.modal', '.modal', function () {
                const $modal = $(this);
                const $dialog = $modal.find('.modal-dialog');
                if ($dialog.hasClass('modal-fullscreen')) {
                    $dialog.removeClass('modal-fullscreen');
                    $modal.find('.btn-toggle-fullscreen i')
                        .removeClass('fa-compress')
                        .addClass('fa-expand');
                }
            });
        }
        modalStandard.initFullscreenToggle = initFullscreenToggle;
        function addEvents(modalTextSearchInput) {
            modalTextSearchInput.off().on('input', function () {
                const searchText = $(this).val();
                if (!searchText) {
                    showAllConnectors();
                    return;
                }
                showMatchedConnectors(searchText);
            });
        }
        function showAllConnectors() {
            $(`#connectorsDialog .connectorOption`).showElement();
        }
        function showMatchedConnectors(searchText) {
            $(`#connectorsDialog .connectorOption`).each(function (index, element) {
                const connectorText = $(element).text();
                if (!connectorText.containsIgnoreCase(searchText)) {
                    $(element).hideElement();
                    return;
                }
                $(element).showElement();
            });
        }
    })(modalStandard = appn.modalStandard || (appn.modalStandard = {}));
})(appn || (appn = {}));
